import { theme } from "../theme";

export default function TrendBadge({ product }) {
  const last = product.position;
  const prev = product.previous_position;
  if (!last || !prev || last === prev) return null;
  const improved = last < prev;
  const diff = Math.abs(last - prev);
  return (
    <div style={{
      display: "inline-flex", alignItems: "center", gap: 3,
      background: improved ? "#dcfce7" : theme.badSoft,
      border: "1.5px solid " + (improved ? theme.okLine : theme.badLine),
      borderRadius: 8, padding: "3px 8px",
      color: improved ? theme.ok : theme.bad,
      fontSize: 12, fontWeight: 700,
    }}>
      <span style={{ fontVariantNumeric: theme.tnum }}>{improved ? "↑" : "↓"} {diff}</span> {improved ? "lepší" : "horší"}
    </div>
  );
}
